// removed by extract-text-webpack-plugin
module.exports = {"auction-title":"auction-title___21VXL","calendar":"calendar___87MiO","aDropDown":"aDropDown___1KbY1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Navigation/AllAuctions.scss
// module id = I0kU
// module chunks = 57